// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Factors_info_pay__tCLr8 {
    background: var(--color-neutral-100);
    height: -moz-fit-content;
    height: fit-content;
    border: solid 1px var(--color-neutral-800);
    padding: 24px;
    margin-bottom: 24px;
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
}

.Factors_item_info_pay__jAdee {
    margin-bottom: 24px;
}


.Factors_item_info_pay__jAdee>div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--color-neutral-800);
    color: var(--color-neutral-600);
    padding: 16px 0;
}

.Factors_item_info_pay__jAdee>div>svg {
    width: 20px;
    height: 20px;
}

.Factors_btn_info_pay__seXEC {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.Factors_btn_info_pay__seXEC button {
    width: calc(50% - 8px);
    text-align: center;
    padding: 8px 0;
    font-size: .9rem;
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
    color: var(--color-primary);
    background: var(--color-info-200);
}

.Factors_btn_info_pay__seXEC>button:nth-child(1) {
    width: calc(50% - 8px);
    color: #FF8D07;
    background: rgba(255, 139, 7, 0.21);
    padding: 8px 0;
}

/* factor */

.Factors_table_factor__4OxSO {
    overflow: auto;
    
}
.Factors_table_factor__4OxSO table{
    border-color: var(--color-neutral-900) !important;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
}
.Factors_table_factor__4OxSO table,.Factors_table_factor__4OxSO td,.Factors_table_factor__4OxSO th {
    border: 1px solid !important;
    border-color: var(--color-neutral-200);
    font-size: .8rem;
    padding: 8px 4px;
    color: var(--color-neutral-600);
    text-align: right;
}

.Factors_table_factor__4OxSO th {
    background: var(--color-neutral-100);
    color: var(--color-neutral-600);
}

.Factors_table_factor__4OxSO table {
    width: 1200px;
    border-collapse: collapse;
}

.Factors_table_factor__4OxSO thead th {
    background-color: var(--color-white);
    padding: 24px;
    font-size: 1.2rem;
    border: none !important;
}

.Factors_table_factor__4OxSO thead img {
    max-width: 200px;
}

.Factors_table_factor__4OxSO thead th:nth-child(2) {
    text-align: center;
}

.Factors_table_factor__4OxSO thead th:last-child {
    text-align: left;
    font-size: .8rem;

}

@media only screen and (min-width: 768px) {
    .Factors_section_factor__fFQvg {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
    }

    .Factors_info_pay__tCLr8 {
        width: 35%;
    }

    .Factors_table_factor__4OxSO {
        width: calc(65% - 24px);
    }

}

@media only screen and (min-width: 992px) {
    .Factors_section_factor__fFQvg {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
    }

    .Factors_info_pay__tCLr8 {
        width: 30%;
    }

    .Factors_table_factor__4OxSO {
        width: calc(70% - 24px);
    }

    .Factors_table_factor__4OxSO table {
        width: -moz-fit-content;
        width: fit-content;
    }

}

@media only screen and (min-width: 1400px) {
    .Factors_table_factor__4OxSO table {
        width: -moz-fit-content;
        width: fit-content;
        min-width: 850px;

    }
 }
`, "",{"version":3,"sources":["webpack://./src/Styles/Factors.module.css"],"names":[],"mappings":";AACA;IACI,oCAAoC;IACpC,wBAAmB;IAAnB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iDAAiD;IACjD,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;IACtC,2BAA2B;IAC3B,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,mCAAmC;IACnC,cAAc;AAClB;;AAEA,WAAW;;AAEX;IACI,cAAc;;AAElB;AACA;IACI,iDAAiD;IACjD,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,4BAA4B;IAC5B,sCAAsC;IACtC,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,aAAa;IAEb,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;;AAEpB;;AAEA;IACI;QACI,aAAa;QACb,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,uBAAuB;IAC3B;;AAEJ;;AAEA;IACI;QACI,aAAa;QACb,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAkB;QAAlB,kBAAkB;IACtB;;AAEJ;;AAEA;IACI;QACI,uBAAkB;QAAlB,kBAAkB;QAClB,gBAAgB;;IAEpB;CACH","sourcesContent":["\n.info_pay {\n    background: var(--color-neutral-100);\n    height: fit-content;\n    border: solid 1px var(--color-neutral-800);\n    padding: 24px;\n    margin-bottom: 24px;\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n}\n\n.item_info_pay {\n    margin-bottom: 24px;\n}\n\n\n.item_info_pay>div {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid var(--color-neutral-800);\n    color: var(--color-neutral-600);\n    padding: 16px 0;\n}\n\n.item_info_pay>div>svg {\n    width: 20px;\n    height: 20px;\n}\n\n.btn_info_pay {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n}\n\n.btn_info_pay button {\n    width: calc(50% - 8px);\n    text-align: center;\n    padding: 8px 0;\n    font-size: .9rem;\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n    color: var(--color-primary);\n    background: var(--color-info-200);\n}\n\n.btn_info_pay>button:nth-child(1) {\n    width: calc(50% - 8px);\n    color: #FF8D07;\n    background: rgba(255, 139, 7, 0.21);\n    padding: 8px 0;\n}\n\n/* factor */\n\n.table_factor {\n    overflow: auto;\n    \n}\n.table_factor table{\n    border-color: var(--color-neutral-900) !important;\n    border-radius: 8px;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n}\n.table_factor table,.table_factor td,.table_factor th {\n    border: 1px solid !important;\n    border-color: var(--color-neutral-200);\n    font-size: .8rem;\n    padding: 8px 4px;\n    color: var(--color-neutral-600);\n    text-align: right;\n}\n\n.table_factor th {\n    background: var(--color-neutral-100);\n    color: var(--color-neutral-600);\n}\n\n.table_factor table {\n    width: 1200px;\n    border-collapse: collapse;\n}\n\n.table_factor thead th {\n    background-color: var(--color-white);\n    padding: 24px;\n    border: none;\n    font-size: 1.2rem;\n    border: none !important;\n}\n\n.table_factor thead img {\n    max-width: 200px;\n}\n\n.table_factor thead th:nth-child(2) {\n    text-align: center;\n}\n\n.table_factor thead th:last-child {\n    text-align: left;\n    font-size: .8rem;\n\n}\n\n@media only screen and (min-width: 768px) {\n    .section_factor {\n        display: flex;\n        flex-direction: row-reverse;\n        justify-content: space-between;\n    }\n\n    .info_pay {\n        width: 35%;\n    }\n\n    .table_factor {\n        width: calc(65% - 24px);\n    }\n\n}\n\n@media only screen and (min-width: 992px) {\n    .section_factor {\n        display: flex;\n        flex-direction: row-reverse;\n        justify-content: space-between;\n    }\n\n    .info_pay {\n        width: 30%;\n    }\n\n    .table_factor {\n        width: calc(70% - 24px);\n    }\n\n    .table_factor table {\n        width: fit-content;\n    }\n\n}\n\n@media only screen and (min-width: 1400px) {\n    .table_factor table {\n        width: fit-content;\n        min-width: 850px;\n\n    }\n }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info_pay": `Factors_info_pay__tCLr8`,
	"item_info_pay": `Factors_item_info_pay__jAdee`,
	"btn_info_pay": `Factors_btn_info_pay__seXEC`,
	"table_factor": `Factors_table_factor__4OxSO`,
	"section_factor": `Factors_section_factor__fFQvg`
};
export default ___CSS_LOADER_EXPORT___;
